import { render, staticRenderFns } from "./SchoolForm.vue?vue&type=template&id=79ca2f30&scoped=true&"
import script from "./SchoolForm.vue?vue&type=script&lang=js&"
export * from "./SchoolForm.vue?vue&type=script&lang=js&"
import style0 from "./SchoolForm.vue?vue&type=style&index=0&id=79ca2f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ca2f30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79ca2f30')) {
      api.createRecord('79ca2f30', component.options)
    } else {
      api.reload('79ca2f30', component.options)
    }
    module.hot.accept("./SchoolForm.vue?vue&type=template&id=79ca2f30&scoped=true&", function () {
      api.rerender('79ca2f30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/SchoolForm.vue"
export default component.exports